export function WebP({ webp, fallback, alt = '', className = null, imageClassName = null, ...rest }) {
  return (
    <picture className={className}>
      <source srcSet={webp} type="image/webp" />
      <img src={fallback} alt={alt} className={imageClassName} {...rest} />
    </picture>
  );
}
